export default [
    // **默认页 - 首页 1
    {
        path: '/',
        name: 'Home',
        component: resolve => require(['@/view/home/index'], resolve),
        meta: {
            title: '首页'
        }

    },
    // **关于金沙
    {
        path: '/aboutUs',
        name: 'aboutUs',
        component: resolve => require(['@/view/aboutUs/index'], resolve),
        meta: {
            title: '关于金沙'
        }
    },
    // **参观指南
    {
        path: '/tourGuide',
        name: 'tourGuide',
        component: resolve => require(['@/view/tourGuide/index'], resolve),
        meta: {
            title: '参观指南'
        }
    },
    // **服务信息[2级菜单页]
    {
        path: '/serviceInfo',
        name: 'serviceInfo',
        component: resolve => require(['@/view/tourGuide/serviceInfo/index'], resolve),
        meta: {
            title: '参观指南'
        }
    },
    // **服务信息[3级页面]
    {
        path: '/servicePage',
        name: 'servicePage',
        component: resolve => require(['@/view/servicePage/index'], resolve),
        meta: {
            title: '参观指南'
        }
    },
    // **展览导览
    {
        path: '/guide',
        name: 'guide',
        component: resolve => require(['@/view/guide/index'], resolve),
        meta: {
            title: '参观导览',
            keepAlive: true
        }
    },
    // **展品详情页 【遗迹馆】
    {
        path: '/historicalRemains',
        name: 'historicalRemains',
        component: resolve => require(['@/view/guide/historicalRemains/index'], resolve),
        meta: {
            title: '遗迹馆详情',
            keepAlive: false,
            notKeepHeader: true
        }
    },
    // **404
    {
        path: '*',
        name: '404',
        component: resolve => require(['@/components/404'], resolve),
        meta: {
            title: '404'
        }
    }
]



// WEBPACK FOOTER //
// ./src/router/module/common.js